import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

export const ARTICLES = [
  {
    id: 'updating-classical-hypnotherapy-for-modern-cognitive-science',
    slug: 'updating-classical-hypnotherapy-for-modern-cognitive-science',
    titleKey: 'articles.articleOneTitle',
    snippetKey: 'articles.articleOneSnippet',
    date: '2026-02-02',
    path: '/blog/updating-classical-hypnotherapy-for-modern-cognitive-science',
    markdownFile: '/blog/updating-classical-hypnotherapy-for-modern-cognitive-science.md',
    keywords: 'hypnotherapy,cognitive science,psychotherapy,ethics',
  },
];

export const ARTICLES_BY_SLUG = Object.fromEntries(ARTICLES.map((a) => [a.slug, a]));

function Blog() {
  const { t } = useTranslation();

  return (
    <div className="blog-page-wrapper">
      <Container className="page-container">
        <SEO
          title={t('articles.pageTitle')}
          description={t('articles.pageDescription')}
          keywords={t('articles.keywords')}
          url="/blog"
        />
        <h1 className="page-title">{t('articles.heading')}</h1>
        <p className="page-content" style={{ marginBottom: '3rem' }}>
          {t('articles.intro')}
        </p>

        <Row>
          {ARTICLES.map((article) => (
            <Col md={12} key={article.id} className="mb-4">
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>
                    <Link to={article.path} className="blog-article-link" style={{ textDecoration: 'none' }}>
                      {t(article.titleKey)}
                    </Link>
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted" style={{ fontSize: '0.9rem' }}>
                    {new Date(article.date).toLocaleDateString(undefined, {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </Card.Subtitle>
                  <Card.Text style={{ marginTop: '1rem' }}>{t(article.snippetKey)}</Card.Text>
                  <Link to={article.path} className="btn btn-primary">
                    {t('articles.readMore')}
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Blog;
